import Parse from 'parse';
import _, { isObject } from 'lodash';
import moment from 'moment';
import localSettings from './localSettings.json';

const { REACT_APP_FITER_ENV = 'production' } = process.env;

const PARSE_APPLICATION_KEY =
  localSettings[`PARSE_APPLICATION_KEY_${REACT_APP_FITER_ENV}`];
const PARSE_JAVASCRIPT_KEY =
  localSettings[`PARSE_JAVASCRIPT_KEY_${REACT_APP_FITER_ENV}`];

console.log('REACT_APP_FITER_ENV', REACT_APP_FITER_ENV);

Parse.serverURL = 'https://parseapi.back4app.com'; // This is your Server URL
Parse.initialize(
  PARSE_APPLICATION_KEY, // This is your Application ID
  PARSE_JAVASCRIPT_KEY // This is your Javascript key
);

const Institution = Parse.Object.extend('Institution');
const Avatar = Parse.Object.extend('Avatars');
const Student = Parse.Object.extend('Student');
const Course = Parse.Object.extend('Course');
const Answers = Parse.Object.extend('Answers');
const Pulse = Parse.Object.extend('Pulse');
const User = Parse.Object.extend('User');
const Area = Parse.Object.extend('Area');
const UsersSheet = Parse.Object.extend('UsersSheet');

const getCurrentUser = async () => {
  try {
    const currentUser = Parse.User.current();
    if (currentUser == null) return null;

    const userQuery = new Parse.Query(Parse.User)
      .equalTo('objectId', currentUser.id)
      .include('course')
      .include('area');

    const role = await new Parse.Query(Parse.Role)
      .equalTo('users', currentUser)
      .first();

    const roles = await new Parse.Query(Parse.Role)
      .equalTo('users', currentUser)
      .find();

    const userInfo = await userQuery.first();

    const course = userInfo.get('course');
    const area = userInfo.get('area');

    return {
      ...userInfo,
      id: userInfo.id,
      roleName: role && role.get('name'),
      courseLabel: course && course.get('label'),
      courseId: course && course.id,
      areaLabel: area && area.get('label'),
      areaId: area && area.id,
      name: userInfo.get('name'),
      birthday: userInfo.get('birthday'),
      email: userInfo.get('email'),
      cpf: userInfo.get('cpf'),
      institutionId: userInfo.get('institutionId'),
      selfie: userInfo.get('selfie'),
      subject: userInfo.get('subject'),
      languages: userInfo.get('languages'),
      phone: userInfo.get('phone'),
      professionalXP: userInfo.get('professionalXP'),
      empoyledOrStudying: userInfo.get('empoyledOrStudying'),
      interestAreas: userInfo.get('interestAreas'),
      roles: roles.map(role => role.get('name'))
    };
  } catch (err) {
    console.error(err);

    Parse.User.logOut();
  }
};
// este método irá substituir o getUserByArea porém ainda não está finalizado
const getUsersByArea2 = async (areaId, monthFilter) => {
  const currentUser = Parse.User.current();
  if (currentUser == null) return null;
  const { firstDayOfMonth, lastDayOfMonth } = getCurrentMonthRange({
    monthFilter
  });
  const area = pointify('Area', areaId);
  const queryUsers = new Parse.Query(User)
    .equalTo('area', area)
    .equalTo('active', true);

  const pulsesQuery = new Parse.Query(Pulse)
    .include('user')
    .include('user.course')
    .greaterThan('createdAt', firstDayOfMonth)
    .lessThan('createdAt', lastDayOfMonth)
    .matchesKeyInQuery('user', 'objectId', queryUsers)
    .limit(10000);
  const result = await pulsesQuery.find();
  return result.map(pulse => {
    const user = pulse.get('user');
    const course = user && user.get('course');
    return {
      userId: user.id,
      happiness: pulse.get('happiness'),
      archetype: pulse.get('archetype'),
      health: pulse.get('health'),
      courseName: course && course.get('label'),
      selfie: user.get('selfie')
    };
  });
};
const getUserHistory2 = async userId => {
  const user = pointify('_User', userId);
  const pulsesQuery = new Parse.Query(Pulse)
    .equalTo('user', user)
    .include('obsAuthor')
    .limit(1000)
    .descending('createdAt');

  const result = await pulsesQuery.find();
  return result.map(pulse => {
    const obsAuthor = pulse.get('obsAuthor');
    return {
      date: pulse.get('createdAt'),
      obs: pulse.get('obs'),
      obsAuthor: obsAuthor && obsAuthor.get('name'),
      comments: pulse.get('comments')
    };
  });
};

const getUsersByArea = async (areaId, monthFilter) => {
  const currentUser = Parse.User.current();
  if (currentUser == null) return null;
  try {
    const { firstDayOfMonth, lastDayOfMonth } = getCurrentMonthRange({
      monthFilter: String(monthFilter).replace('-', '-01-')
    });
    const transformEvasionInCards = evasion => {
      switch (evasion) {
        case 'Muito Baixo':
          return 1;
        case 'Baixo':
          return 2;

        case 'Medio Alto':
          return 3;

        default:
          return 1;
      }
    };
    const getHappiness = data => {
      return data ? data.happiness : '';
    };
    const getAdherence = data => {
      return data ? data.adherence : '';
    };
    const getTurnover = data => {
      return data ? data.turnover : '';
    };

    const queryArea = new Parse.Query(Area).equalTo('objectId', areaId);

    const resultAreaQuery = await queryArea.first();
    const areaInfo = {
      id: resultAreaQuery.id,
      label: resultAreaQuery.get('label'),
      averageWage: resultAreaQuery.get('averageWage'),
      turnoverLimit: resultAreaQuery.get('turnoverLimit')
    };

    const queryUsers = new Parse.Query(User)
      .equalTo('area', {
        __type: 'Pointer',
        className: 'Area',
        objectId: areaId
      })
      .limit(10000);

    const usersList = await queryUsers.find();
    const queryPulses = new Parse.Query(Pulse)
      .containedIn(
        'user',
        usersList.map(user => user.id)
      )
      .descending('createdAt')
      .limit(10000);

    const queryAllPulses = (await queryPulses.find()).map(pulse => ({
      user: pulse.get('user').id,
      happiness: pulse.get('happiness'),
      archetype: pulse.get('archetype'),
      comments: pulse.get('comments'),
      obs: pulse.get('obs'),
      createdAt: pulse.get('createdAt')
    }));
    const queryCurrentMonthPulses = queryPulses
      .greaterThan('createdAt', firstDayOfMonth)
      .lessThan('createdAt', lastDayOfMonth);

    const currentMonthPulsesList = (await queryCurrentMonthPulses.find()).map(
      pulse => ({
        userId: pulse.get('user').id,
        turnover: transformEvasionInCards(pulse.get('evasionLabel')),
        adherence: pulse.get('archetype'),
        happiness: pulse.get('happiness')
      })
    );
    const getUserHistory = user => {
      try {
        return _.filter(queryAllPulses, { user }).map(pulse => ({
          eventType: 'pulse',
          eventLabel: 'Pulso Medido',
          eventDate:
            (moment.isDate(new Date(pulse.createdAt)) &&
              moment(new Date(pulse.createdAt)).format('DD/MM/YYYY HH:MM')) ||
            '-',
          eventData: [
            `Taxa de felicidade ${pulse.happiness}`,
            `Taxa de aderência: ${pulse.archetype}`,
            pulse.comments ? `Comentários: ${pulse.comments}` : '',
            pulse.obs ? `Observação do coordenador ${pulse.obs}` : ''
          ]
        }));
      } catch (err) {
        console.log(err);
        return [];
      }
    };
    const usersDataList = usersList.map(user => ({
      id: user.id,
      name: user.get('name'),
      selfie: user.get('selfie'),
      empoyledOrStudying: user.get('empoyledOrStudying'),
      interestAreas: user.get('interestAreas'),
      email: user.get('email'),
      birthday: user.get('birthday'),
      cpf: user.get('cpf'),
      professionalXP: user.get('professionalXP'),
      area: user.get('area').id,
      adherence: getAdherence(
        _.filter(currentMonthPulsesList, { userId: user.id })[0]
      ),
      happiness: getHappiness(
        _.filter(currentMonthPulsesList, { userId: user.id })[0]
      ),
      turnover: getTurnover(
        _.filter(currentMonthPulsesList, { userId: user.id })[0]
      ),
      history: getUserHistory(user.id),
      courseId: user.get('courseId')
    }));
    const result = {
      ...areaInfo,
      users: _.filter(usersDataList, {
        area: areaId
      })
    };

    return result;
  } catch {
    return null;
  }
};

const getAllCourses = async () => {
  const query = new Parse.Query(Course);

  const currentUser = await getCurrentUser();
  if (
    currentUser &&
    currentUser.institutionId &&
    currentUser.institutionId.id
  ) {
    query.equalTo('institution', {
      __type: 'Pointer',
      className: 'Institution',
      objectId: currentUser.institutionId.id
    });
    query.limit(10000);
  }

  try {
    const coursesRef = await query.find();
    const courses = _.map(coursesRef, courseRef => ({
      name: courseRef.get('name'),
      label: courseRef.get('label'),
      id: courseRef.id
    }));
    return courses;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const saveStudentData = async studentData => {
  const newStudent = new Student();
  const newCourse = new Course();
  newCourse.id = studentData.course;

  const { name, cpf, email, phone } = studentData;
  await newStudent.save({
    name,
    cpf,
    email,
    phone,
    birthday: new Date(studentData.birthday),
    course: newCourse
  });
};

const getAnswers = async ({
  sortKey = 'createdAt',
  sortDirection = 'descending',
  searchKey,
  searchValue
}) => {
  const query = new Parse.Query(Answers);

  if (searchKey && searchValue)
    _.invoke(query, 'startsWith', searchKey, searchValue); // Search
  _.invoke(query, sortDirection, sortKey); // Sort

  const results = await query.find();
  return _.map(results, answer => ({
    nameCandidate: answer.get('nameCandidate'),
    nameInterviewer: answer.get('nameInterviewer'),
    answers: answer.get('answers'),
    comments: answer.get('comments'),
    result: answer.get('result'),
    date: moment(answer.get('createdAt')).format('DD/MM/YYYY, H:mm:ss'),
    courseId: _.get(answer.get('course'), 'id', ''),
    course: answer.get('course')
  }));
};

const getStudents = async () => {
  const query = new Parse.Query(User);
  try {
    const results = await query.descending('createdAt').find();
    return _.map(results, answer => ({
      name: answer.get('name'),
      id: answer.id,
      courseId: _.get(answer.get('course'), 'id', '')
    }));
  } catch (err) {
    return [];
  }
};

const getUser = async id => {
  const query = new Parse.Query(User);

  const answer = await query.get(id);
  return {
    name: answer.get('name'),
    id: answer.id,
    courseId: answer.get('courseId')
  };
};

const savePulse = async (answerValues, questionsKeys) => {
  const newPulse = new Pulse();
  const { id, institutionId } = await getCurrentUser();
  const answers = Object.assign(
    {},
    ...questionsKeys.map(key => ({ [key]: +answerValues[key] }))
  );

  const userQuery = new Parse.Query(User);
  const user = await userQuery.get(id);
  const response = await newPulse.save({
    user,
    studentName: user.get('name'),
    courseId: user.get('courseId'),
    answers,
    comments: answerValues.comments,
    institutionId
  });
  return response;
};

const getEvasionList = async ({
  monthFilter = '',
  usersFilter = [],
  areasFilter = [],
  unitFilter = [],
  institution = ''
}) => {
  const { firstDayOfMonth, lastDayOfMonth } = getCurrentMonthRange({
    monthFilter: monthFilter.value
  });
  const evasionQuery = new Parse.Query(Pulse)
    .include('user')
    .include('user.area')
    .greaterThan('createdAt', firstDayOfMonth)
    .lessThan('createdAt', lastDayOfMonth)
    .equalTo('institutionId', institution)
    .equalTo('evasionLabel', 'Medio Alto')
    .limit(10000);

  //
  if (usersFilter.length > 0) {
    evasionQuery.containedIn(
      'user',
      usersFilter.map(user => user.value)
    );
  } else if (areasFilter.length > 0) {
    const usersQuery = new Parse.Query(Parse.User)
      .equalTo('institutionId', institution)
      .containedIn(
        'area',
        areasFilter.map(({ value }) => value)
      );
    evasionQuery.matchesQuery('user', usersQuery);
  } else if (unitFilter.length > 0) {
    const userQuery = new Parse.Query(Parse.User).containedIn(
      'unit',
      unitFilter.map(({ value }) => value)
    );

    evasionQuery.matchesQuery('user', userQuery);
  }

  const _evasionData = await evasionQuery.find();
  const evasionData = _evasionData.map(item => {
    const author = item.get('obsAuthor');
    const user = item.get('user');
    const area = user && user.get('area');
    return {
      id: item.id,
      name: user && user.get('name'),
      authorName: author && author.get('name'),
      areaName: area && area.get('label'),
      comments: area && item.get('comments')
    };
  });
  const evasionCount = await evasionQuery.count();

  return { evasionData, evasionCount };
};

const getPulses = async ({
  sortKey = 'createdAt',
  sortDirection = 'descending',
  searchKey,
  searchValue,
  page = 1,
  limit = 100,
  areasFilter = [],
  usersFilter = [],
  monthFilter = '',
  unitFilter = [],
  commentsFilter,
  turnoverFilter
}) => {
  const { institutionId } = await getCurrentUser();
  const { firstDayOfMonth, lastDayOfMonth } = getCurrentMonthRange({
    monthFilter: monthFilter.value
  });
  const institution = {
    __type: 'Pointer',
    className: 'Institution',
    objectId: institutionId.id
  };
  const query = new Parse.Query(Pulse)
    .include('user')
    .greaterThan('createdAt', firstDayOfMonth)
    .lessThan('createdAt', lastDayOfMonth)
    .equalTo('institutionId', institution)
    .include('user')
    .include('user.unit');

  if (commentsFilter) {
    query.notEqualTo('comments', '');
  }
  if (turnoverFilter) {
    query.equalTo('evasionLabel', 'Medio Alto');
  }
  if (sortDirection === 'descending') {
    query.descending('createdAt');
  } else {
    query.ascending('createdAt');
  }
  const areas = [];

  if (usersFilter.length > 0) {
    const usersListFilter = usersFilter.map(({ value }) => ({
      __type: 'Pointer',
      className: '_User',
      objectId: value
    }));
    query.containedIn('user', usersListFilter);
  }
  if (areasFilter.length > 0) {
    const usersQuery = new Parse.Query(Parse.User)
      .equalTo('institutionId', institution)
      .containedIn(
        'area',
        areasFilter.map(area => area.value)
      );
    query.matchesQuery('user', usersQuery);
  } else if (unitFilter.length > 0) {
    const usersQuery = new Parse.Query(Parse.User).containedIn(
      'unit',
      unitFilter.map(({ value }) => value)
    );
    query.matchesQuery('user', usersQuery);
  }

  const count = await query.count();
  const { evasionCount, evasionData } = await getEvasionList({
    areasFilter,
    monthFilter,
    unitFilter,
    institution,
    usersFilter
  });

  const evasionMedia = Number((evasionCount / count) * 100).toFixed(0);
  query.limit(limit).skip((page - 1) * limit);

  const results = await query.find();
  const data = await Promise.all(
    results.map(result => {
      const user = result.get('user').toJSON();
      const userObject = result.get('user');
      const course = userObject && userObject.get('course');
      const area = userObject && userObject.get('area');
      const unit = userObject && userObject.get('unit');
      const _data = {
        answers: result.get('answers'),
        happiness: result.get('happiness'),
        archetype: result.get('archetype'),
        health: result.get('health'),
        evasion: result.get('evasion'),
        evasionLabel: result.get('evasionLabel'),
        comments: result.get('comments'),
        firstDropdownValue: result.get('firstDropdownValue') || '',
        secondDropdownValue: result.get('secondDropdownValue') || '',
        action: result.get('action') || '',
        date: moment(result.get('createdAt')).format('DD/MM/YYYY, H:mm:ss'),
        obs: result.get('obs'),
        pulseId: result.id,
        authorId: result.get('obsAuthor'),
        areaName: area && area.get('label'),
        courseName: course && course.get('name'),
        unitName: unit && unit.get('name')
      };
      return { ..._data, ...user };
    })
  );
  return { data, count, evasionMedia, evasionData };
};

const login = async (username, password) => {
  if (!username || !password) throw new Error('CPF ou senha inválidos.');
  try {
    await Parse.User.logIn(username, password);
    await getCurrentUser();
  } catch (err) {
    const { code } = err;
    if (code === 101) throw new Error('CPF ou senha inválidos.');
    throw new Error('Ocorreu um erro, tente novamente mais tarde.');
  }
};

const loggout = () => Parse.User.logOut();

const signup = async userData => {
  const user = new Parse.User();
  _.forEach(userData, (value, key) => user.set(key, value));
  user.set('username', _.get(userData, 'email'));
  try {
    await user.signUp();
    await getCurrentUser();
  } catch (err) {
    const { code } = err;
    if (code === 202 || code === 202) throw new Error('Email já cadastrado.');
    throw new Error('Ocorreu um erro.');
  }
};

const sendRecoverPasswordEmail = Parse.User.requestPasswordReset;
const getCurrentMonthRange = ({ monthFilter = false }) => {
  const day = monthFilter ? new Date(monthFilter) : new Date();
  const firstDayOfMonth = new Date(day.getFullYear(), day.getMonth(), 1);

  const lastDayOfMonth = new Date(
    day.getFullYear(),
    day.getMonth() + 1,
    0,
    23,
    59
  );
  return {
    firstDayOfMonth,
    lastDayOfMonth
  };
};

const getCurrentPulse = async () => {
  const currentUser = await Parse.User.current();
  if (!currentUser) return {};

  try {
    const { firstDayOfMonth, lastDayOfMonth } = getCurrentMonthRange({});
    const userQuery = new Parse.Query(User);
    const user = await userQuery.get(currentUser.id);
    const query = new Parse.Query(Pulse);
    query.equalTo('user', user);

    query.greaterThan('createdAt', firstDayOfMonth);
    query.lessThan('createdAt', lastDayOfMonth);

    return query.first();
  } catch (err) {
    console.error(err);
    return {};
  }
};

const getPulsesForUser = async () => {
  const currentUser = await Parse.User.current();
  if (!currentUser) return {};

  try {
    const today = new Date();
    const initialDate = new Date(today.getFullYear(), today.getMonth() - 3, 0);
    const finalDate = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      today.getDay()
    );
    const userQuery = new Parse.Query(User);
    const user = await userQuery.get(currentUser.id);
    const query = new Parse.Query(Pulse);
    query.equalTo('user', user);

    query.greaterThan('createdAt', initialDate);
    query.lessThan('createdAt', finalDate);

    const parseObjects = await query.find();
    return _.map(parseObjects, parseObject => ({
      happiness: parseObject.get('happiness'),
      archetype: parseObject.get('archetype'),
      monthIndex: new Date(parseObject.get('createdAt')).getMonth(),
      year: new Date(parseObject.get('createdAt')).getFullYear(),
      answers: parseObject.get('answers')
    }));
  } catch (err) {
    console.error(err);
    return {};
  }
};

const getAllPulsesByMonth = async ({ areasFilter = [], unitFilter = [] }) => {
  const currentUser = await Parse.User.current();
  const { institutionId } = await getCurrentUser();
  if (!currentUser) return {};

  try {
    const usersQuery = new Parse.Query(User).equalTo(
      'institutionId',
      institutionId
    );
    // .limit(10000)
    if (areasFilter.length > 0) {
      usersQuery.containedIn(
        'area',
        areasFilter.map(({ value }) => pointify('Area', value))
      );
    }
    if (unitFilter.length > 0) {
      usersQuery.containedIn(
        'unit',
        unitFilter.map(({ value }) => pointify('Unit', value))
      );
    }
    // const filteredUsers = await usersQuery.find()

    const query = new Parse.Query(Pulse)
      // .containedIn('user', filteredUsers)
      .matchesQuery('user', usersQuery)
      .ascending('createdAt')
      .limit(100000);

    const parseObjects = await query.find();
    const sumPulseData = [];
    const sumObject = {};
    const totalOfPulses = parseObjects.length;
    let lastMonthVerified = -1;
    let parseIndex = -1;
    let indexCounter = -1;
    let generalCounter = 0;
    for (const parseObject of parseObjects) {
      if (
        lastMonthVerified != new Date(parseObject.get('createdAt')).getMonth()
      ) {
        generalCounter = 0;
        parseIndex++;
        sumObject.sumHappiness = 0;
        sumObject.sumArchetype = 0;
        sumObject.answers = {
          'question-0': 0,
          'question-1': 0,
          'question-2': 0,
          'question-3': 0,
          'question-4': 0,
          'question-5': 0,
          'question-6': 0,
          'question-7': 0
        };
        lastMonthVerified = new Date(parseObject.get('createdAt')).getMonth();
        indexCounter++;
      }
      generalCounter++;
      const _answers = parseObject.get('answers');
      for (let index = 0; index <= 7; index++) {
        sumObject.answers[`question-${index}`] += _answers[`question-${index}`];
      }

      sumObject.sumHappiness += parseObject.get('happiness');
      sumObject.sumArchetype += parseObject.get('archetype');

      sumPulseData[parseIndex] = {
        happiness: Math.round(sumObject.sumHappiness / generalCounter),
        archetype: Math.round(sumObject.sumArchetype / generalCounter),
        monthIndex: new Date(parseObject.get('createdAt')).getMonth(),
        year: new Date(parseObject.get('createdAt')).getFullYear(),
        filterKey: `${new Date(
          parseObject.get('createdAt')
        ).getFullYear()}-${new Date(parseObject.get('createdAt')).getMonth() +
        1}`,
        answers: {
          'question-0': sumObject.answers['question-0'] / generalCounter,
          'question-1': sumObject.answers['question-1'] / generalCounter,
          'question-2': sumObject.answers['question-2'] / generalCounter,
          'question-3': sumObject.answers['question-3'] / generalCounter,
          'question-4': sumObject.answers['question-4'] / generalCounter,
          'question-5': sumObject.answers['question-5'] / generalCounter,
          'question-6': sumObject.answers['question-6'] / generalCounter,
          'question-7': sumObject.answers['question-7'] / generalCounter
        },
        index: indexCounter
      };
    }

    return sumPulseData;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const getInstitution = async () => {
  try {
    const { institutionId } = await getCurrentUser();
    const query = new Parse.Query(Institution);
    const currentInstitution = await query.get(institutionId.id);

    const queryAvatar = new Parse.Query(Avatar);
    const currentAvatar = await queryAvatar.get(
      currentInstitution.get('avatar').toJSON().objectId
    );

    return {
      logo: currentInstitution.get('logo'),
      name: currentInstitution.get('name'),
      avatar: currentAvatar.toJSON().avatar
    };
  } catch (err) {
    console.error(err);
    return undefined;
  }
};

const updateMontlyWage = async (areaId, averageWage) => {
  try {
    const query = new Parse.Query(Area);

    const area = await query.get(areaId);
    area.set('averageWage', Number(averageWage));
    return area.save();
  } catch (err) {
    // console.log(err)
    return undefined;
  }
};

const updatePulseObs = async ({
  obs,
  pulseId,
  currentUserId,
  firstDropdownValue,
  secondDropdownValue,
  action
}) => {
  try {
    const author = {
      __type: 'Pointer',
      className: '_User',
      objectId: currentUserId
    };
    const query = new Parse.Query(Pulse);

    const pulse = await query.get(pulseId);
    pulse.set('obs', obs);
    pulse.set('obsAuthor', author);
    if (firstDropdownValue) pulse.set('firstDropdownValue', firstDropdownValue);
    if (secondDropdownValue)
      pulse.set('secondDropdownValue', secondDropdownValue);
    if (action) pulse.set('action', action);
    return pulse.save();
  } catch (err) {
    // console.log(err)
    return undefined;
  }
};

const updateUser = async ({ selfie, interestAreas = [], ...userData }) => {
  try {
    const currentUser = await getCurrentUser();
    const userQuery = new Parse.Query(User);
    const user = await userQuery.get(currentUser.id);
    // criar relation aqui
    /* consertar este intervalo
    const usr = Parse.User.current();
    const relation = usr.relation("interestAreas");


    const teste = new Area()
    relation.remove()
    interestAreas.map(area => {
      teste.id = area
      relation.add(teste);
    })
    usr.save()
    usr.save();
    */
    Object.entries(userData).forEach(([key, value]) => {
      user.set(key, value);
    });

    if (selfie && !selfie._url)
      user.set('selfie', new Parse.File('selfie', selfie));

    return user.save();
  } catch (err) {
    console.error(err);
    return undefined;
  }
};

const getArchetype = async () => {
  try {
    const { courseId, roleName } = await getCurrentUser();
    const Questions = Parse.Object.extend('Questions');

    const queryCourse = new Parse.Query(Course).equalTo('objectId', courseId);
    const courseObject = await queryCourse.first();

    const { id: questionsGroupId } = courseObject.get('questionsGroup');
    const queryArchetype = new Parse.Query(Questions)
      .equalTo('questionsGroup', questionsGroupId)
      .equalTo('role', roleName)
      .ascending('order');
    const archetypeList = await queryArchetype.find();
    return archetypeList.map(archetype => {
      return {
        header: archetype.get('header'),
        label: archetype.get('label'),
        answers: archetype.get('answers'),
        layout: archetype.get('layout'),
        hasVariable: archetype.get('hasVariable'),
        tips: archetype.get('tips')
      };
    });
  } catch (err) {
    console.error(err);
    return {};
  }
};

const getUsersByInstituition = async ({ limit = 50, searchValue = '' }) => {
  try {
    const { institutionId } = await getCurrentUser();
    const usersQuery = new Parse.Query(Parse.User)
      .equalTo('institutionId', {
        __type: 'Pointer',
        className: 'Institution',
        objectId: institutionId.id
      })
      .equalTo('active', true)
      .include('area')
      .limit(limit);

    if (searchValue) {
      usersQuery.matches('name', searchValue, 'i');
    }
    const resultList = await usersQuery.find();
    const result = resultList.map(user => ({
      id: user.id,
      name: user.get('name'),
      area: user.get('area'),
      courseId: user.get('courseId')
    }));
    return result;
  } catch (err) {
    console.log(err);
    return [];
  }
};

const getAbstentions = async ({
  institution = '',
  monthFilter = false,
  areasFilter = [],
  unitFilter = [],
  limit = 100,
  page = 1
}) => {
  const currentUser = await getCurrentUser();
  let institutionId = '';
  if (!institution) {
    institutionId = currentUser?.institutionId;
  } else {
    institutionId = pointify('Institution', institution);
  }
  const { firstDayOfMonth, lastDayOfMonth } = getCurrentMonthRange({
    monthFilter: isObject(monthFilter) ? monthFilter.value : monthFilter
  });
  const pulsesQuery = new Parse.Query(Pulse)
    .equalTo('institutionId', institutionId)
    .greaterThan('createdAt', firstDayOfMonth)
    .lessThan('createdAt', lastDayOfMonth)
    .include('user')
    .limit(10000);

  const pulses = await pulsesQuery.find();

  const usersQuery = new Parse.Query(Parse.User)
    .equalTo('institutionId', institutionId)
    .equalTo('active', true)
    .include('area')
    .include('course')
    .ascending('area.label')
    .addAscending('name')
    .notContainedIn(
      'objectId',
      pulses.map(pulse => pulse.get('user') && pulse.get('user').id)
    );
  // .doesNotMatchKeyInQuery('id', 'user', pulsesQuery);
  if (areasFilter.length > 0) {
    usersQuery.containedIn(
      'area',
      areasFilter.map(({ value }) => value)
    );
  }
  if (unitFilter.length > 0) {
    usersQuery.containedIn(
      'unit',
      unitFilter.map(({ value }) => value)
    );
  }
  usersQuery.limit(limit).skip((page - 1) * limit);
  const result = await usersQuery.find();
  const data = result.map(user => {
    const area = user && user.get('area');
    const course = user && user.get('course');
    const unit = user && user.get('unit');
    return {
      name: user && user.get('name'),
      phone: user && user.get('phone'),
      cpf: user.get('cpf'),
      areaLabel: area && area.get('label'),
      courseLabel: course && course.get('label'),
      unitLabel: unit && unit.get('name')
    };
  });
  const count = await usersQuery.count();

  return { data, count };
};

const getAllInstitutions = async () => {
  const query = new Parse.Query(Institution);
  const result = await query.find();

  const institutionsList = result.map(element => element.toJSON());
  return result;
};

const getStudability = async () => {
  const { institutionId } = await getCurrentUser();
  const query = new Parse.Query(Parse.User)
    .equalTo('institutionId', {
      __type: 'Pointer',
      className: 'Institution',
      objectId: institutionId.id
    })
    .equalTo('active', true);
  const totalUsers = await query.count();
  query.equalTo('empoyledOrStudying', true);
  const totalStudying = await query.count();
  const data = {
    totalUsers,
    totalStudying
  };

  return data;
};

const getAreas = async ({ forCurrentUser = false, unitFilter = [] }) => {
  const { id, institutionId } = await getCurrentUser();
  const query = new Parse.Query(Area).limit(10000).equalTo('institution', {
    __type: 'Pointer',
    className: 'Institution',
    objectId: institutionId.id
  });
  if (forCurrentUser) {
    query.equalTo('manager', {
      __type: 'Pointer',
      className: '_User',
      objectId: id
    });
  }
  if (unitFilter.length > 0) {
    query.containedIn(
      'unit',
      unitFilter.map(unit => ({
        __type: 'Pointer',
        className: 'Unit',
        objectId: unit.value
      }))
    );
  }

  const areas = await query.find();
  return areas.map(area => ({
    id: area.id,
    label: area.get('label'),
    value: area.get('label')
  }));
};

const getUnits = async (forCurrentUser = true) => {
  try {
    const { institutionId } = await getCurrentUser();
    const Unit = Parse.Object.extend('Unit');
    const query = new Parse.Query(Unit).equalTo('institution', {
      __type: 'Pointer',
      className: 'Institution',
      objectId: institutionId.id
    });

    const _unitsList = await query.find();
    const unitsList = _unitsList.map(unit => ({
      id: unit.id,
      name: unit.get('name')
    }));

    return unitsList;
  } catch {
    return [];
  }
};

/*
 ** FUNÇÕES PARA OBTER AS INFORMAÇÕES GERAIS
 */
const pointify = (className, objectId) => ({
  __type: 'Pointer',
  className,
  objectId
});

const getGeneralData = async monthFilter => {
  const monthRange = getCurrentMonthRange({ monthFilter });
  const institutionsList = await getInstitutionsList();
  const respondentsList = await getRespondentsCountByInstitution(
    institutionsList,
    monthRange
  );
  const abstentionsList = await getAbstentionsCountByInstitution(
    institutionsList,
    monthRange
  );
  const evasionList = await getEvasionCountByInstitution(
    institutionsList,
    monthRange
  );
  // console.log(institutionsList, respondentsList, abstentionsList, evasionList)
  const resumedList = await institutionsList.map(institution => {
    const respondents = respondentsList.find(
      inst => inst.institutionId == institution.id
    );
    const abstentions = abstentionsList.find(
      inst => inst.institutionId == institution.id
    );
    const evasion = evasionList.find(
      inst => inst.institutionId == institution.id
    );
    return {
      institutionId: institution.id,
      institutionName: institution.name,
      respondents: respondents?.count,
      abstentions: abstentions?.count,
      evasion: evasion?.count
    };
  });

  return resumedList;
};

const getInstitutionsList = async () => {
  const query = new Parse.Query(Institution).equalTo('active', true);
  const _result = await query.find();
  const result = _result.map(institution => ({
    id: institution.id,
    name: institution.get('name')
  }));

  return result;
};

const getRespondentsCountByInstitution = async (
  institutionsList = [],
  monthRange
) => {
  const { firstDayOfMonth, lastDayOfMonth } = monthRange;
  let respondentsList = [];
  const promise = institutionsList.map(async institution => {
    const query = new Parse.Query(Pulse);
    const institutionId = pointify('Institution', institution.id);
    query.greaterThan('createdAt', firstDayOfMonth);
    query.lessThan('createdAt', lastDayOfMonth);
    const count = await query.equalTo('institutionId', institutionId).count();
    return {
      institutionId: institution.id,
      institutionName: institution.name,
      count
    };
  });
  await Promise.all(promise)
    .then(result => (respondentsList = result))
    .catch(err => console.error(err));
  return respondentsList;
};

const getAbstentionsCountByInstitution = async (
  institutionsList = [],
  monthRange
) => {
  const { firstDayOfMonth, lastDayOfMonth } = monthRange;
  let abstentionsList = [];
  const promise = institutionsList.map(async institution => {
    const institutionId = pointify('Institution', institution.id);

    const pulsesQuery = new Parse.Query(Pulse)
      .equalTo('institutionId', institutionId)
      .greaterThan('createdAt', firstDayOfMonth)
      .lessThan('createdAt', lastDayOfMonth);

    const usersQuery = new Parse.Query(Parse.User)
      .equalTo('institutionId', institutionId)
      .doesNotMatchKeyInQuery('name', 'studentName', pulsesQuery)
      .equalTo('active', true);
    // .doesNotMatchKeyInQuery('user', 'objectId', pulsesQuery)

    const count = await usersQuery.count();
    return {
      institutionId: institution.id,
      institutionName: institution.name,
      count
    };
  });
  await Promise.all(promise)
    .then(result => (abstentionsList = result))
    .catch(err => console.error(err));
  return abstentionsList;
};

const getEvasionCountByInstitution = async (
  institutionsList = [],
  monthRange
) => {
  const { firstDayOfMonth, lastDayOfMonth } = monthRange;
  let evasionList = [];
  const promise = institutionsList.map(async institution => {
    const query = new Parse.Query(Pulse);
    const institutionId = pointify('Institution', institution.id);
    query
      .greaterThan('createdAt', firstDayOfMonth)
      .lessThan('createdAt', lastDayOfMonth)
      .equalTo('evasionLabel', 'Medio Alto');
    const count = await query.equalTo('institutionId', institutionId).count();
    return {
      institutionId: institution.id,
      institutionName: institution.name,
      count
    };
  });
  await Promise.all(promise)
    .then(result => (evasionList = result))
    .catch(err => console.error(err));
  return evasionList;
};

const getActiveUsersCount = async institutionId =>
  new Parse.Query(User)
    .equalTo('active', true)
    .equalTo('institutionId', pointify('Institution', institutionId))
    .count();

async function uploadSheet(institutionId, file) {
  const user = Parse.User.current();
  const institution = pointify('Institution', institutionId);

  const sheet = new Parse.File(file?.name, file);
  const teste = new FileReader();
  teste.readAsBinaryString(file);
  const fff = await teste.onload(e => {
    console.log(e);
  });
  const newSheet = new UsersSheet();
  return newSheet.save({
    user,
    institution,
    sheet
  });
}

async function getUserInfo(userId) {
  const query = new Parse.Query(User)
    .include('area')
    .include('curse')
    .include('unit')
    .equalTo('objectId', userId);

  const user = await query.first();
  if (user) {
    const photo = user.get('selfie');
    const course = user.get('course');
    const area = user.get('area');
    const unit = user.get('unit');
    return {
      name: user.get('name'),
      email: user.get('email'),
      phone: user.get('phone'),
      birthday: user.get('birthday'),
      profilePhoto: photo && photo._url,
      areaName: area && area.get('label'),
      courseName: course && course.get('label'),
      unitName: unit && unit.get('name')
    };
  }
  return {};
}

async function getCurrentHappinessArchetype(userId) {
  const user = pointify('_User', userId);
  const query = new Parse.Query(Pulse)
    .equalTo('user', user)
    .descending('createdAt');

  const result = await query.first();
  if (result) {
    return {
      happiness: result.get('happiness'),
      archetype: result.get('archetype'),
      health: result.get('health'),
      evasionLabel: result.get('evasionLabel')
    };
  }
  return {};
}

async function fetchUserHistory(userId) {
  const user = pointify('_User', userId);
  const query = new Parse.Query(Pulse)
    .equalTo('user', user)
    .descending('createdAt');

  const result = await query.find();

  return result.map(pulse => {
    return {
      title: 'Pulso Medido',
      createdAt: pulse.get('createdAt'),
      archetype: pulse.get('archetype'),
      happiness: pulse.get('happiness'),
      health: pulse.get('health'),
      comments: pulse.get('comments'),
      obs: pulse.get('obs'),
      evasionLabel: pulse.get('evasionLabel')
    };
  });
}

const getCvData = userId => Parse.Cloud.run('get-cv-data', { userId });
// const getAreas = () => Parse.Cloud.run('get-areas');

const listAreas = ({ limit, page, filters, sort, areaId }) =>
  Parse.Cloud.run('areas:list', { limit, page, filters, sort, areaId });

const importUsers = ({ institutionId, users, role }) =>
  Parse.Cloud.run('users:import', { institutionId, users, role });

export default {
  getAllCourses,
  saveStudentData,
  getAnswers,
  getStudents,
  savePulse,
  getPulses,
  login,
  loggout,
  getCurrentUser,
  signup,
  sendRecoverPasswordEmail,
  getCurrentPulse,
  getPulsesForUser,
  getAllPulsesByMonth,
  getInstitution,
  updateUser,
  getCvData,
  getArchetype,
  getAbstentions,
  getAllInstitutions,
  getStudability,
  updatePulseObs,
  getUser,
  getAreas,
  getUsersByInstituition,
  listAreas,
  getUsersByArea,
  updateMontlyWage,
  getUnits,
  getGeneralData,
  getActiveUsersCount,
  uploadSheet,
  importUsers,
  getUserInfo,
  getCurrentHappinessArchetype,
  fetchUserHistory
};
